export enum ActionKind {
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  LoginFailed = 'LOGIN_FAILED',
  LoginSuccess = 'LOGIN_SUCCESS',
}

export type Action = {
  type: ActionKind;
  payload: any;
};
